import React from 'react';
import { ArrowRight, MapPin, Package, ShoppingBag, ShoppingBasket } from 'lucide-react';
import SiteFooter from './components/SiteFooter.jsx';

export default function Landing() {
  return <div className="landing">
    <header className="landing-header">
      <a className="landing-brand" href="/" aria-label="SabayBuy home">
        <ShoppingBag size={22} strokeWidth={2.2} aria-hidden="true" />
        <span>SabayBuy</span>
      </a>
      <nav className="landing-nav" aria-label="Main navigation">
        <a href="#how-it-works">How it works</a>
        <a className="landing-signin" href="/auth">Sign in</a>
        <a className="landing-button landing-button-small" href="/auth?mode=signup">Get started <ArrowRight size={16} aria-hidden="true" /></a>
      </nav>
    </header>

    <main className="landing-main">
    <section className="landing-hero" aria-labelledby="landing-title">
      <div className="landing-copy">
        <p className="landing-kicker"><span aria-hidden="true"></span>CROWDSOURCED PEER-TO-PEER SHOPPING</p>
        <h1 id="landing-title">Need an item from across town?<br /><small><em>Start a pasabuy request or trip.</em></small></h1>
        <p className="landing-intro">Pick up something from the nearby sari-sari store, a market, or a place farther away. Match with someone already heading in that direction and arrange a face-to-face handoff.</p>
        <div className="landing-actions">
          <a className="landing-button" href="/auth?mode=signup">Make your first request <ArrowRight size={18} aria-hidden="true" /></a>
          <a className="landing-text-link" href="/auth">Already have an account? Sign in</a>
        </div>
        <p className="landing-small-note">A quick local errand or a longer journey—SabayBuy fits both.</p>
      </div>

      <div className="landing-visual" role="img" aria-label="Illustration of a neighborhood errand bringing an item from a nearby store">
        <div className="itinerary-top"><span>THE LITTLE THINGS, BROUGHT HOME</span><span className="itinerary-mark">SB—01</span></div>
        <div className="itinerary-route">
          <div className="itinerary-city"><span className="itinerary-dot"></span><small>FROM</small><strong>Nearby</strong><span>Your neighborhood</span></div>
          <div className="itinerary-line" aria-hidden="true"><MapPin size={17} /></div>
          <div className="itinerary-city itinerary-destination"><span className="itinerary-dot"></span><small>HEADING TO</small><strong>The corner store</strong><span>Just around the way</span></div>
        </div>
        <div className="itinerary-ticket">
          <div className="ticket-icon"><ShoppingBasket size={24} aria-hidden="true" /></div>
          <div><small>ON YOUR LIST</small><strong>Something you need</strong><span>Brought along on the way</span></div>
          <span className="ticket-stamp">PASABUY</span>
        </div>
        <div className="itinerary-caption"><MapPin size={15} aria-hidden="true" /> Around the corner or farther along.</div>
      </div>
    </section>

    <section className="landing-process" id="how-it-works" aria-labelledby="process-title">
      <div className="landing-section-heading">
        <p className="landing-kicker">THREE STEPS, ONE MEETUP</p>
        <h2 id="process-title">From “I wish I had that”<br />to right here.</h2>
      </div>
      <ol className="landing-steps">
        <li><span className="step-number">01</span><h3>Make a request</h3><p>Tell us what you’re looking for and where you’d like to meet.</p></li>
        <li><span className="step-number">02</span><h3>Find someone heading there</h3><p>Connect with a nearby errand-runner or someone making a longer trip, then coordinate the details together.</p></li>
        <li><span className="step-number">03</span><h3>Meet and exchange</h3><p>Meet in person, check the item, then exchange cash directly with the person bringing it.</p></li>
      </ol>
    </section>

    <section className="landing-cash-note" aria-labelledby="cash-title">
      <span className="cash-note-index">A NOTE ON PAYMENT</span>
      <div><h2 id="cash-title">Cash stays between you.</h2><p>At your meetup, the buyer pays the person bringing the item directly in cash. SabayBuy does not process, collect, hold, or guarantee payments. Agree on details together and inspect the item before paying.</p></div>
      <a href="/auth?mode=signup" aria-label="Create an account to get started">Get started <ArrowRight size={17} aria-hidden="true" /></a>
    </section>
    </main>

    <SiteFooter className="landing-footer" />
  </div>;
}
